import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async () => {
    const { data } = await axios.get(API_URL + `/api/highlight/SMNSB`);
    console.log(data)
    return data;
}

export const getNews = async () => {
    console.log("first")
    const { data } = await axios.get(API_URL + `/api/news/`);
    console.log("news:", data)
    return data;
}

export const getEvents = async () => {
    const { data } = await axios.get(API_URL + `/api/events/SMNSB`);
    console.log(data)
    return data;
}

export const getEventsinner = async () => {
    const { data } = await axios.get(API_URL + `/api/events/All/SMNSB`);
    console.log(data)
    return data;
}

export const getBirthdays = async () => {
    const { data } = await axios.get(API_URL + `/api/birthdays/SMNSB`);
    console.log(data)
    return data;
}

export const getGallery = async () => {
    const { data } = await axios.get(API_URL + `/api/gallery/SMNSB`);
    return data;
}

export const getGalleryInner = async () => {
    const { data } = await axios.get(API_URL + `/api/gallery/All/SMNSB`);
    return data;
}

export const getSubGallery = async (id) => {
    console.log(id)
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
    console.log(data)
    return data;
}

export const getNotification = async () => {
    const { data } = await axios.get(API_URL + `/api/notification/SMNSB`, getHeader());
    return data;
}

export const getTopper = async () => {
    const { data } = await axios.get(API_URL + `/api/topper/SMNSB`, getHeader());
    return data;
}

export const getOnlineRegistration = async () => {
    const { data } = await axios.get(API_URL + `/api/onlineRegistration/SMNSB`, getHeader());
    return data;
}

export const getSliders = async () => {
    const { data } = await axios.get(API_URL + `/api/slider/SMNSB`, getHeader());
    return data;
}

export const getPrincipalMessage = async () => {
    const { data } = await axios.get(API_URL + `/api/PrincipalMessage/SMNSB`, getHeader());
    return data;
}

// export const getMedia = async() => {
//     const { data } = await axios.get(API_URL + `/api/media/SHSJ`, getHeader());
//     return data;
// } 

export const getVideo = async () => {
    const { data } = await axios.get(API_URL + `/api/video/all/SMNSB`, getHeader());
    return data;
}

export const postTransferCertificate = async (name, admission) => {
    console.log(name, admission)
    const { data } = await axios.post(API_URL + `/api/tc/SMNSB`, { name, admission }, getHeader());
    return data;
}

export const form = async (formData, header) => {
    const { data } = await axios.post(API_URL + `/api/form/SMNSB`, formData, header);
    return data;
}
